// Configuração de permissões por role
export const ROLES = {
  ADMIN: 0,
  GERENTE: 1,
  COBRADOR: 2,
  BANCA: 3,
  AGENTE: 4
};

// Mapeamento de menus permitidos por role
export const MENU_PERMISSIONS = {
  [ROLES.ADMIN]: [
    'sellers',
    'terminals', 
    'bancas',
    'regions',
    'lotteries',
    'modalities',
    'regionsconfigs',
    'results',
    'descargas',
    'entries',
    'financialtransactions',
    'users',
    'collectors',
    'tasks',
    'appversions',
    'settings',
    'notifications'
  ],
  [ROLES.GERENTE]: [
    'sellers',
    'terminals',
    'regions', 
    'lotteries',
    'modalities',
    'regionsconfigs',
    'results',
    'descargas',
    'entries',
    'financialtransactions',
    'users',
    'collectors',
    'notifications'
  ],
  [ROLES.BANCA]: [
    'sellers',
    'terminals',
    'regions', 
    'lotteries',
    'modalities',
    'regionsconfigs',
    'results',
    'descargas',
    'entries',
    'financialtransactions',
    'users',
    'collectors',
    'notifications'
  ],
  [ROLES.COBRADOR]: [
    'collectors',           // Cobradores
    'sellers',             // Vendedores
    'financialtransactions', // Lançamentos
    'regionsconfigs'       // Configurações da Região
  ],
  [ROLES.AGENTE]: [
    'results'              // Apenas Resultados
  ]
};

// Rota padrão por role (onde redirecionar após login)
export const DEFAULT_ROUTES = {
  [ROLES.ADMIN]: '/dashboard',
  [ROLES.GERENTE]: '/dashboard', 
  [ROLES.BANCA]: '/dashboard',
  [ROLES.COBRADOR]: '/sellers',
  [ROLES.AGENTE]: '/results'
};

// Verifica se o usuário tem permissão para acessar uma rota/menu
export function hasPermission(userRole, menuKey) {
  // Garantir que userRole seja um número
  const role = parseInt(userRole);
  
  // Verificar se o role é válido
  if (isNaN(role)) {
    return false;
  }
  
  const permissions = MENU_PERMISSIONS[role];
  return permissions && permissions.includes(menuKey);
}

// Obtém a rota padrão para um role
export function getDefaultRoute(userRole) {
  return DEFAULT_ROUTES[userRole] || '/sellers';
}

// Filtra menus baseado no role do usuário
export function getAvailableMenus(userRole) {
  return MENU_PERMISSIONS[userRole] || [];
}

// Verifica se é um role válido
export function isValidRole(role) {
  return Object.values(ROLES).includes(role);
}

export default {
  ROLES,
  MENU_PERMISSIONS,
  DEFAULT_ROUTES,
  hasPermission,
  getDefaultRoute,
  getAvailableMenus,
  isValidRole
}; 